import { Button, Form, Modal, Row, Space, notification } from 'antd';
import Icons from 'assets/icons';
import { InputFields, Notification } from 'components/common';
import React, {useEffect, useImperativeHandle, useState} from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { FIELD_TYPE } from 'types/enums';
import { DataFormField } from 'types/models/input-field-type';
import { storeService } from "api";
import { setEBCType } from 'redux/reducer/examBtnClick';
import { EXAM_BTN_CLICK_TYPE } from 'types/enums/examination';
const SaveNewGoiThuoc = React.forwardRef((props, ref) => {
    let dispatch = useAppDispatch();
    
    const [data, setData] = useState<any>(null);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [form] = Form.useForm();
    const fields = [
      {
        label: "Tên gói thuốc",
        type: FIELD_TYPE.INPUT,
        name: 'name',
        css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
        rules: [{required: true, message: "Hãy nhập tên cho gói thuốc"}]
      },
      {
        label: "Mô tả",
        name: "description",
        css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
        type: FIELD_TYPE.INPUT
      },
      {
        label: "Ghi chú",
        name: "note",
        css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
        type: FIELD_TYPE.INPUT
      }
    ]

    useImperativeHandle(ref, () => ({
      openModal: () => {
        openModal();
      },
      closeModal: () => {
        closeModal();
      },
      getValue: form.getFieldValue,
      getValues: form.getFieldsValue,
      setValue: form.setFieldValue,
      setValues: form.setFieldsValue,
      resetFields: form.resetFields,
      setData: setData
    }));
    const openModal = () => {
      setIsModalOpen(true)
    }
    const closeModal = () => {
      setIsModalOpen(false)
    }
    const removeNullDonThuoc = (dt) => {
      let res = []
      dt.map((it) => {
        delete it.id;
        it.tenThuoc && it.tenThuoc !== "" && it.tenThuoc !== undefined ? res = [...res, {
          id: it.idThuoc,
          name: it.tenThuoc,
          donViTinh: it.donVi,
          hamLuong: it.nongDo,
          duocChinh: it.hoatChat,
          soLuong: it.soLuong,
          lieuDung: it.lieuDung,
        }]: null;
      })
      return res;
    }
    const handleOk = async () => {
        form.validateFields().then(async (values) => {
            const thuocs = removeNullDonThuoc([...data]);
            const tmp = {
                name: values.name,
                description: values.description,
                note: values.note,
                medicines: thuocs
            }
            try {
              let response = await storeService.postGoiThuoc(tmp)
              dispatch(setEBCType(EXAM_BTN_CLICK_TYPE.RELOAD_LIST_GT))
              Notification("success", "Lưu thành công!")
              closeModal()
            } catch (err) {
              
							Notification("error", "Lỗi xảy ra khi thêm gói thuốc")
						}
        }).catch(err => notification.error({message: "Lỗi xảy ra!"}))
    }
    useEffect(() => {
      form.resetFields()
    }, [data])
    return (
      <Row className='save-new-gt'>
        <Modal title={"Lưu gói thuốc mới"}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={closeModal}
          closable={false}
          footer={[
            <>
            <Space>
              <Button icon={<Icons.close />} onClick={closeModal}>Hủy</Button>
              <Button icon={<Icons.save />} type='primary' onClick={handleOk}>Lưu</Button>
            </Space>
            </>
          ]}
        >
          <Form form={form} size="large">
            <Row gutter={[0, 16]}>
              <InputFields data={fields} />
            </Row>
          </Form>
        </Modal>
      </Row>
    );
})
export default SaveNewGoiThuoc;